import styled from 'styled-components';

export const RightTableCell = styled.td`
  text-align: right;

  button {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
